import LRUMap from '../../map/LRUMap'

export type ImageMeta = {
  width: number
  height: number
  ratio: number
  loaded: boolean
}

const maxCachedImages = 4000
const imgCache = new LRUMap<string, ImageMeta>(maxCachedImages)

export function preloadImageMeta(
  src?: string | null,
): Promise<ImageMeta | undefined> {
  if (!src) return Promise.resolve(undefined)

  const cached = imgCache.get(src)
  if (cached?.loaded) return Promise.resolve(cached)

  return new Promise((resolve) => {
    const img = new Image()

    img.onload = () => {
      const width = img.naturalWidth || 0
      const height = img.naturalHeight || 0

      const meta = {
        loaded: width > 0 && height > 0,
        width,
        height,
        ratio: height > 0 ? width / height : 1,
      }

      imgCache.set(src, meta)
      resolve(meta)
    }

    img.onerror = () => {
      const meta = { loaded: false, width: 0, height: 0, ratio: 1 }
      imgCache.set(src, meta)
      resolve(meta)
    }

    img.src = src
  })
}

export function getImageMeta(src?: string | null) {
  if (!src) return undefined
  return imgCache.get(src)
}
